export enum AuthAction {
  LOGIN_REQUEST = 'LOGIN_REQUEST',
  REGISTER_REQUEST = 'REGISTER_REQUEST',
  ACE_ACCOUNT_SUBMIT = 'ACE_ACCOUNT_SUBMIT',
  CONFIRM_REQUEST = 'CONFIRM_REQUEST',
  RESEND_CONFIRMATION_CODE = 'RESEND_CONFIRMATION_CODE',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  COMPLETE_NEW_PASSWORD = 'COMPLETE_NEW_PASSWORD',
  LOGOUT = 'LOGOUT',
}

export const AuthScope = 'auth';
